import { Injectable, inject } from '@angular/core';
import { Either, Left, Right } from 'purify-ts';
import { ApiErrorCatalog } from '../../../domain/core/api-error';
import { BulkRepositoryFailure } from '../../../domain/bulk/failure';
import { IBulkRepository } from '../../../domain/bulk/i-bulk-repository';
import {
  BulkJob,
  BulkJobAccepted,
  BulkJobOptions,
  SendBulkProps,
} from '../../../domain/bulk/types';
import { ApiResponse } from '../../../util/type';
import { IHttpClient } from '../../services/httpClient/interface';
import { withQuery } from '../util';
import { RawBulkJob, mapBulkJob } from './bulk-mapper';

const REJECTION_NAMES = [
  'MissingBulkVariablesError',
  'PhoneNumberNotAllowedForRoleError',
  'TemplateNotAllowedForRoleError',
];

@Injectable({
  providedIn: 'root',
})
export class RealBulkRepository implements IBulkRepository {
  private httpClient = inject(IHttpClient);

  public async sendTemplateBulk(
    props: SendBulkProps
  ): Promise<Either<BulkRepositoryFailure, BulkJobAccepted>> {
    try {
      const { body } = await this.httpClient.post<ApiResponse<BulkJobAccepted>>(
        '/whatsapp/messages/template/bulk',
        props
      );
      return Right(body.data);
    } catch (error) {
      const serverMessage = ApiErrorCatalog.isOneOf(error, REJECTION_NAMES)
        ? ApiErrorCatalog.extractBody(error)?.message?.trim()
        : undefined;

      if (serverMessage) {
        return Left(BulkRepositoryFailure.rejectedByServer(serverMessage));
      }

      return Left(
        BulkRepositoryFailure.fromApiError({
          error,
          fallbackMessage: 'Não foi possível criar o disparo em massa.',
        })
      );
    }
  }

  public async getJob(
    bulkJobId: string,
    options: BulkJobOptions = {}
  ): Promise<Either<BulkRepositoryFailure, BulkJob>> {
    try {
      const url = withQuery(`/whatsapp/messages/template/bulk/${encodeURIComponent(bulkJobId)}`, {
        failuresLimit: options.failuresLimit,
        failuresOffset: options.failuresOffset,
      });

      const { body } = await this.httpClient.get<ApiResponse<RawBulkJob>>(url);
      return Right(mapBulkJob(body.data));
    } catch (error) {
      return Left(
        BulkRepositoryFailure.fromApiError({
          error,
          fallbackMessage: 'Não foi possível carregar o disparo em massa.',
        })
      );
    }
  }
}
